<div class="adminis-spinner" [ngClass]="{'adminis-spinner--center': isCenter}">
  <div class="adminis-spinner__dot1"></div>
  <div class="adminis-spinner__dot2"></div>
</div>
